export default function isString(input) {
    return typeof input === 'string' || input instanceof String;
}



//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/moment/src/lib/utils/is-string.js
// module id = 329
// module chunks = 0